"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var CopyrightLine = function CopyrightLine() {
    var currentYear = new Date().getFullYear();
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledMargin, null, /*#__PURE__*/ react_1.default.createElement("span", null, "\xA9 Copyright ", currentYear, " Prior Inc."), /*#__PURE__*/ react_1.default.createElement("ul", null, /*#__PURE__*/ react_1.default.createElement("li", null, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/terms-of-use"
    }, "Terms of Use")), /*#__PURE__*/ react_1.default.createElement("li", null, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/privacy-policy"
    }, "Privacy Policy")))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "CopyrightLine__Wrapper",
    componentId: "sc-16q8ked-0"
})(["background-color:", ";padding:18px 0;", " color:", ";text-align:center;& span{display:flex;justify-content:center;padding:4px 0;}& ul{display:flex;flex-direction:row;justify-content:center;}& ul li{margin-right:24px;&:last-of-type{margin-right:0;}& a{display:block;padding:4px 0;&:hover{color:", ";}}}", "{padding:0;text-align:left;& ul,& span{justify-content:flex-start;}}"], _theme_1.palette.ivory, _theme_1.type.labelSmall, _theme_1.palette.ink, _theme_1.palette.brown, _utils_1.mediaQuery('tablet'));
var StyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "CopyrightLine__StyledMargin",
    componentId: "sc-16q8ked-1"
})(["display:flex;flex-direction:column;align-items:center;", "{flex-direction:row;justify-content:space-between;height:48px;}", "{height:64px;}", "{height:72px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
exports.default = CopyrightLine;
